import { animated, useTransition } from "@react-spring/web";

import { Button, Stack } from "@mui/material";

import useLocalStorage from "@app/common/hooks/useLocalStorage";

const NotificationBanner = ({
  localStorageName,
  children,
  button,
}: {
  localStorageName?: string;
  children: React.ReactNode;
  button?: React.ReactNode;
}) => {
  const [notificationBannerDismissed, setNotificationBannerDismissed] =
    useLocalStorage(localStorageName ?? "", false);

  const handleDismiss = () => button ?? setNotificationBannerDismissed(true);

  const transitions = useTransition(!notificationBannerDismissed, {
    from: { opacity: 0, height: 0, minHeight: 0, marginBottom: 0 },
    enter: { opacity: 1, height: "auto", minHeight: 76, marginBottom: 16 },
    leave: { opacity: 0, height: 0, minHeight: 0, marginBottom: 0 },
  });

  return (
    <div>
      {transitions((style, shouldShow) => {
        return (
          shouldShow && (
            <animated.div style={{ overflow: "hidden", ...style }}>
              <Stack
                alignItems="center"
                direction="row"
                justifyContent="space-between"
                sx={{
                  minWidth: "100%",
                  width: "100%",
                  p: "12px 20px",
                  bgcolor: "shades.ghost.500",
                  borderRadius: "6px",
                }}
              >
                {children}
                {button ?? (
                  <Button
                    variant="contained"
                    sx={{ minWidth: "100px", height: "44px" }}
                    onClick={handleDismiss}
                  >
                    Dismiss
                  </Button>
                )}
              </Stack>
            </animated.div>
          )
        );
      })}
    </div>
  );
};

export default NotificationBanner;
